angular.module('AccountingBoxApp')
  .controller('PasswordCtrl', function ($scope, User, $location, Auth,$stateParams) {
    $scope.cp = {};
    $scope.errors = {};

    $scope.changePassword =function (cp,form) {
     if(form.$valid) {
      if(cp.password===cp.passwordConfirmation){
        $scope.passwordsNotEqual = false;
        console.log('accestoken:',$stateParams.access_token);
        User.changePassword({access_token:$stateParams.access_token},cp,function () {
          $scope.changedPassword = true;
        });
      }else{
        $scope.passwordsNotEqual = true;
      }
      }
      // body...
    };
    /*$scope.login = function(form) {
     $scope.submitted = true;
      if(form.$valid) {
      $scope.loginResult = User.login({
          email: $scope.user.email,
          password: $scope.user.password
        }, function(login) {
          // console.log(login);
        Auth.setCurrentUser(login.user);
      var next = $location.nextAfterLogin || '/';
      if(login.user.isBookkeeper){
        next = $location.nextAfterLogin ||'/boekhouder/bedrijven';
      }

      console.log(next);

  //    User.$clearCache();

      $location.nextAfterLogin = null;
      $location.path(next);
      }, function(err){
        console.log(err);
          if(err.data.error.code==='LOGIN_FAILED'){
            $scope.errors.other = 'Onjuiste inloggegevens.'
          }else if(err.data.error.code==='LOGIN_FAILED_EMAIL_NOT_VERIFIED'){
            $scope.errors.other = 'Het e-mailadres is nog niet bevestigd.'
          }else{
          $scope.errors.other = err.data.error.message;
        }
      });
}
};*/
});
